const ON = 'ON';
const OFF = 'OFF';

const FEATURE_BP4 = process.env.REACT_APP_FEATURE_BP4 === 'ON' ? ON : OFF;
const FEATURE_FEI = process.env.REACT_APP_FEATURE_FEI === 'ON' ? ON : OFF;

const features = {
	BP4: FEATURE_BP4,
	FEI: FEATURE_FEI
};

export const flags = {
	BP4: 'BP4',
	FEI: 'FEI'
};

export const isFeatureOn = flag => features[flag] === ON;
